import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import AdminLayout from "../../components/layout/AdminLayout/AdminLayout";
import ImageUploader from "../../components/common/ImageUploader/ImageUploader";

import eventGalleryService from "../../services/event/eventGalleryService";
import UploadModules from "../../constants/uploadModules";

import sweetAlert from "../../utils/sweetAlert";

export default function EventGallery() {

    const { id } = useParams();
    const navigate = useNavigate();
    const [photos, setPhotos] = useState([]);

    const [loading, setLoading] = useState(true);

    const [editingPhotoId, setEditingPhotoId] = useState(null);

    const [uploadForm, setUploadForm] = useState({

        photoName: "",
        photoCaption: "",
        displayOrder: 0

    });

    useEffect(() => {

        loadPhotos();

    }, []);

    const loadPhotos = async () => {

        try {

            setLoading(true);

            const response = await eventGalleryService.getPhotos(id);

            if (response.success) {

                setPhotos(response.data);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Failed to load photos.");

        }
        finally {

            setLoading(false);

        }

    };

    const resetForm = () => {

        setEditingPhotoId(null);

        setUploadForm({

            photoName: "",
            photoCaption: "",
            displayOrder: 0

        });

    };

    const handleSave = async () => {

        if (!uploadForm.photoName) {

            toast.error("Please upload image.");

            return;

        }

        try {

            let response;

            if (editingPhotoId) {

                response = await eventGalleryService.updatePhoto(
                    editingPhotoId,
                    uploadForm
                );

            }
            else {

                response = await eventGalleryService.addPhoto(
                    id,
                    uploadForm
                );

            }

            if (response.success) {

                toast.success(response.message);

                resetForm();

                loadPhotos();

            }
            else {

                toast.error(response.message);

            }

        }
        catch (error) {

            console.log(error);

            toast.error("Something went wrong.");

        }

    };

    const handleDelete = async (photoId) => {

        const confirmed = await sweetAlert.confirmDelete();

        if (!confirmed) {

            return;

        }

        const response = await eventGalleryService.deletePhoto(photoId);

        if (response.success) {

            toast.success(response.message);

            loadPhotos();

        }
        else {

            toast.error(response.message);

        }

    };

    return (

        <AdminLayout>

            <div className="page-header d-flex justify-content-between align-items-center">

                <h2>Event Gallery</h2>

                <button
                    className="btn btn-secondary"
                    onClick={() => navigate("/events")}
                >
                    ← Back
                </button>

            </div>

            <div className="card mb-4">

                <div className="card-body">

                    <div className="row g-3">

                        <div className="col-lg-4">

                            <label className="form-label">

                                Photo

                            </label>

                            <ImageUploader
                                module={UploadModules.EVENT}
                                value={uploadForm.photoName}
                                onUpload={(path) =>
                                    setUploadForm({
                                        ...uploadForm,
                                        photoName: path
                                    })
                                }
                            />

                        </div>

                        <div className="col-lg-4">

                            <label className="form-label">

                                Caption

                            </label>

                            <input
                                className="form-control"
                                value={uploadForm.photoCaption}
                                onChange={(e) =>
                                    setUploadForm({
                                        ...uploadForm,
                                        photoCaption: e.target.value
                                    })
                                }
                            />

                        </div>

                        <div className="col-lg-2">

                            <label className="form-label">

                                Display Order

                            </label>

                            <input
                                type="number"
                                className="form-control"
                                value={uploadForm.displayOrder}
                                onChange={(e) =>
                                    setUploadForm({
                                        ...uploadForm,
                                        displayOrder: Number(e.target.value)
                                    })
                                }
                            />

                        </div>

                        <div className="col-lg-2 d-flex align-items-end">

                            <button
                                className="btn btn-primary w-100"
                                onClick={handleSave}
                            >
                                {
                                    editingPhotoId
                                        ? "Update"
                                        : "Upload"
                                }
                            </button>

                        </div>

                        {
                            editingPhotoId &&

                            <div className="col-lg-2">

                                <button
                                    className="btn btn-secondary w-100"
                                    onClick={resetForm}
                                >
                                    Cancel
                                </button>

                            </div>
                        }

                    </div>

                </div>

            </div>

            <div className="row">

                {

                    loading ?

                        <div className="text-center">

                            Loading...

                        </div>

                        :

                        photos.length === 0 ?

                            <div className="text-center">

                                No Photos Found

                            </div>

                            :

                            photos.map(photo => (

                                <div
                                    className="col-lg-3 col-md-4 mb-4"
                                    key={photo.photoId}
                                >

                                    <div className="card h-100">

                                        <img
                                            src={`${process.env.REACT_APP_SERVER_URL}${photo.photoName}`}
                                            alt=""
                                            className="card-img-top"
                                            style={{
                                                height: "180px",
                                                objectFit: "cover"
                                            }}
                                        />

                                        <div className="card-body">

                                            <h6>

                                                {photo.photoCaption || "-"}

                                            </h6>

                                            <small>

                                                Display Order : {photo.displayOrder}

                                            </small>

                                        </div>

                                        <div className="card-footer d-flex gap-2">

                                            <button
                                                className="btn btn-warning btn-sm w-50"
                                                onClick={() => {

                                                    setEditingPhotoId(photo.photoId);

                                                    setUploadForm({

                                                        photoName: photo.photoName,

                                                        photoCaption: photo.photoCaption || "",

                                                        displayOrder: photo.displayOrder

                                                    });

                                                }}
                                            >
                                                Edit
                                            </button>

                                            <button
                                                className="btn btn-danger btn-sm w-50"
                                                onClick={() => handleDelete(photo.photoId)}
                                            >
                                                Delete
                                            </button>

                                        </div>

                                    </div>

                                </div>

                            ))

                }

            </div>

        </AdminLayout>

    );

}